// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type AdminLocationDrawerQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type AdminLocationDrawerQuery = { __typename?: 'Query', location: { __typename?: 'Location', id: string, name: string, effectiveCode: string, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType, name: string }, roomType?: { __typename?: 'RoomType', id: string, name: string } | null | undefined, parents: Array<{ __typename?: 'Location', id: string, name: string, path?: string | null | undefined, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType, name: string } }>, locations: Array<{ __typename?: 'Location', id: string, name: string, path?: string | null | undefined, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType, name: string } }> } };

export type SaveAdminLocationDrawerMutationVariables = Types.Exact<{
  input: Types.SaveLocationsInput;
}>;


export type SaveAdminLocationDrawerMutation = { __typename?: 'Mutation', saveLocations: { __typename?: 'SaveLocationsResult', locations: Array<{ __typename?: 'Location', id: string, name: string, effectiveCode: string, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType, name: string }, roomType?: { __typename?: 'RoomType', id: string, name: string } | null | undefined, parents: Array<{ __typename?: 'Location', id: string, name: string, path?: string | null | undefined, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType, name: string } }>, locations: Array<{ __typename?: 'Location', id: string, name: string, path?: string | null | undefined, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType, name: string } }> }> } };

export type AdminLocationDrawer_LocationFragment = { __typename?: 'Location', id: string, name: string, effectiveCode: string, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType, name: string }, roomType?: { __typename?: 'RoomType', id: string, name: string } | null | undefined, parents: Array<{ __typename?: 'Location', id: string, name: string, path?: string | null | undefined, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType, name: string } }>, locations: Array<{ __typename?: 'Location', id: string, name: string, path?: string | null | undefined, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType, name: string } }> };

export type AdminLocationDrawer_AssociatedLocationFragment = { __typename?: 'Location', id: string, name: string, path?: string | null | undefined, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType, name: string } };

export const AdminLocationDrawer_AssociatedLocationFragmentDoc = gql`
    fragment AdminLocationDrawer_AssociatedLocation on Location {
  id
  name
  path
  type {
    code
    name
  }
}
    `;
export const AdminLocationDrawer_LocationFragmentDoc = gql`
    fragment AdminLocationDrawer_Location on Location {
  id
  name
  effectiveCode
  type {
    code
    name
  }
  roomType {
    id
    name
  }
  parents {
    ...AdminLocationDrawer_AssociatedLocation
  }
  locations {
    ...AdminLocationDrawer_AssociatedLocation
  }
}
    ${AdminLocationDrawer_AssociatedLocationFragmentDoc}`;
export const AdminLocationDrawerDocument = gql`
    query AdminLocationDrawer($id: ID!) {
  location(id: $id) {
    ...AdminLocationDrawer_Location
  }
}
    ${AdminLocationDrawer_LocationFragmentDoc}`;

/**
 * __useAdminLocationDrawerQuery__
 *
 * To run a query within a React component, call `useAdminLocationDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminLocationDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminLocationDrawerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminLocationDrawerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminLocationDrawerQuery, AdminLocationDrawerQueryVariables> & ({ variables: AdminLocationDrawerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminLocationDrawerQuery, AdminLocationDrawerQueryVariables>(AdminLocationDrawerDocument, options);
      }
export function useAdminLocationDrawerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminLocationDrawerQuery, AdminLocationDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminLocationDrawerQuery, AdminLocationDrawerQueryVariables>(AdminLocationDrawerDocument, options);
        }
// @ts-ignore
export function useAdminLocationDrawerSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminLocationDrawerQuery, AdminLocationDrawerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminLocationDrawerQuery, AdminLocationDrawerQueryVariables>;
export function useAdminLocationDrawerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminLocationDrawerQuery, AdminLocationDrawerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminLocationDrawerQuery | undefined, AdminLocationDrawerQueryVariables>;
export function useAdminLocationDrawerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminLocationDrawerQuery, AdminLocationDrawerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminLocationDrawerQuery, AdminLocationDrawerQueryVariables>(AdminLocationDrawerDocument, options);
        }
export type AdminLocationDrawerQueryHookResult = ReturnType<typeof useAdminLocationDrawerQuery>;
export type AdminLocationDrawerLazyQueryHookResult = ReturnType<typeof useAdminLocationDrawerLazyQuery>;
export type AdminLocationDrawerSuspenseQueryHookResult = ReturnType<typeof useAdminLocationDrawerSuspenseQuery>;
export type AdminLocationDrawerQueryResult = ApolloReactCommon.QueryResult<AdminLocationDrawerQuery, AdminLocationDrawerQueryVariables>;
export const SaveAdminLocationDrawerDocument = gql`
    mutation SaveAdminLocationDrawer($input: SaveLocationsInput!) {
  saveLocations(input: $input) {
    locations {
      ...AdminLocationDrawer_Location
    }
  }
}
    ${AdminLocationDrawer_LocationFragmentDoc}`;

/**
 * __useSaveAdminLocationDrawerMutation__
 *
 * To run a mutation, you first call `useSaveAdminLocationDrawerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAdminLocationDrawerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAdminLocationDrawerMutation, { data, loading, error }] = useSaveAdminLocationDrawerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveAdminLocationDrawerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveAdminLocationDrawerMutation, SaveAdminLocationDrawerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveAdminLocationDrawerMutation, SaveAdminLocationDrawerMutationVariables>(SaveAdminLocationDrawerDocument, options);
      }
export type SaveAdminLocationDrawerMutationHookResult = ReturnType<typeof useSaveAdminLocationDrawerMutation>;
export type SaveAdminLocationDrawerMutationResult = ApolloReactCommon.MutationResult<SaveAdminLocationDrawerMutation>;